import React from "react";
import { useStoreState, useStoreActions } from "easy-peasy";
import { Container } from "reactstrap";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { ReactQueryDevtools } from "react-query/devtools";

import Home from "./Home";
import API from "../api/API";
import Navigation from "./Navigation";
import Spots from "./Spots";
import Login from "./Login";
import Logout from "./static/Logout";
import Signup from "./Signup";
import Activate from "./Activate";
import Profile from "./Profile/Profile";
import PrivateRoute from "./PrivateRoute";
import Toast from "./Toast";
import { useEffect } from "react";
import Spot from "./SpotPage/Spot";
import BuoySwells from "./BuoySwells";
import SpotCreateForm from "./SpotForm/SpotCreateForm";

const App = () => {
  const toasts = useStoreState((state) => state.toasts.items);
  const loggedIn = useStoreState((state) => state.auth.loggedIn);
  const addToast = useStoreActions((actions) => actions.toasts.addToast);
  const getLoginStatus = useStoreActions(
    (actions) => actions.auth.getLoginStatus
  );

  const login = useStoreActions((actions) => actions.auth.login);
  const logout = useStoreActions((actions) => actions.auth.logout);
  const signup = useStoreActions((actions) => actions.auth.signup);
  useEffect(() => {
    getLoginStatus();
  }, [getLoginStatus]);
  return (
    <>
      <BrowserRouter>
        <Navigation loggedIn={loggedIn} logout={logout} />
        <div className="toast-container">
          {toasts.map((t) => (
            <Toast
              key={t.timestamp}
              color={t.color}
              timestamp={t.timestamp}
              message={t.message}
            />
          ))}
        </div>
        <Container fluid>
          <Switch>
            <Route path="/buoy">
              <BuoySwells />
            </Route>
            <Route
              path="/login"
              render={(routeProps) => <Login login={login} {...routeProps} />}
            />
            <Route path="/signup">
              <Signup signup={signup} />
            </Route>
            <PrivateRoute path="/home">
              <Home api={API} />
            </PrivateRoute>
            <PrivateRoute path="/spots">
              <Spots />
            </PrivateRoute>
            <PrivateRoute path="/spot/:id">
              <Spot />
            </PrivateRoute>
            <PrivateRoute path="/createspot">
              <SpotCreateForm />
            </PrivateRoute>
            <PrivateRoute path="/profile">
              <Profile />
            </PrivateRoute>
            <Route path="/activate">
              <Activate />
            </Route>
            <Route path="/logout">
              <Logout />
            </Route>

            <Route
              path="/"
              render={() => {
                addToast({
                  color: "info",
                  message: "Redirected",
                });
                return <Redirect to="/home" />;
              }}
            ></Route>
          </Switch>
        </Container>
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </>
  );
};

export default App;
